// This file is @generated by `pnpm generate-browser-variant-aliases`.
// Do not edit by hand.
//
// Modules with a `.browser` sibling. The default module is aliased to its
// `.browser` variant for the browser bundle in
// `packages/next/src/build/create-compiler-aliases.ts`. Paths are relative to
// `packages/next/dist` (extension omitted).
export const browserVariantModules = [
  'client/components/client-boundary-params',
  'client/components/instant-samples',
  'client/components/instant-validation/impl',
  'client/components/navigation-dynamic-rendering',
  'client/components/server-async-storage',
  'client/components/unstable-rethrow',
] as const
